export const SCROLL_START = 'scrollStart';
export const SCROLL_END = 'scrollEnd';
export const SCROLL = 'scroll';
